import { Fragment, FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import SoldWordIcon from 'dibs-icons/exports/Sold';
import Unavailable from 'dibs-icons/exports/Unavailable';
import { itemStatus } from '../pdpMessages';
import styles from './PdpSharedUnpurchasableHeader.scss';

import { PdpSharedUnpurchasableHeader_item } from './__generated__/PdpSharedUnpurchasableHeader_item.graphql';

type ComponentProps = { item: PdpSharedUnpurchasableHeader_item };

const PdpSharedUnpurchasableHeaderComponent: FC<ComponentProps> = ({ item }) => {
    const { title, isSold } = item;
    const UnpurchasableIcon = isSold ? SoldWordIcon : Unavailable;

    return (
        <Fragment>
            <div className={styles.title}>{title}</div>
            <div className={styles.statusContainer}>
                <span className={styles.itemStatus}>{itemStatus}</span>
                <span className={styles.iconContainer}>
                    <UnpurchasableIcon className={styles.icon} />
                </span>
            </div>
        </Fragment>
    );
};

export const PdpSharedUnpurchasableHeader = createFragmentContainer(
    PdpSharedUnpurchasableHeaderComponent,
    {
        item: graphql`
            fragment PdpSharedUnpurchasableHeader_item on Item {
                title
                isSold
            }
        `,
    }
);
